import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, Box, Chip, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketIdentification } from '../../../../state';

const TagsEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    dispatch(updateTicketIdentification({ tags: event.target.value as string[] }));
  };

  const handleDeleteTag = (tagToDelete: string) => (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const currentTags = currentTicket?.identification.tags || [];
    const newTags = currentTags.filter(tag => tag !== tagToDelete);
    dispatch(updateTicketIdentification({ tags: newTags }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Tags</InputLabel>
      <Select
        multiple
        value={currentTicket?.identification.tags || []}
        onChange={handleChange}
        input={<OutlinedInput label="Tags" />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as string[]).map((value) => (
              <Chip 
                key={value} 
                label={value} 
                size="small" 
                onDelete={handleDeleteTag(value)}
                onMouseDown={(event) => {
                  event.stopPropagation();
                }}
                onClick={(event) => {
                  event.stopPropagation();
                }}
              />
            ))}
          </Box>
        )}
      >
        <MenuItem value="urgent">Urgent</MenuItem>
        <MenuItem value="critical">Critical</MenuItem>
        <MenuItem value="enhancement">Enhancement</MenuItem>
        <MenuItem value="documentation">Documentation</MenuItem>
        <MenuItem value="training">Training</MenuItem>
        <MenuItem value="integration">Integration</MenuItem>
      </Select>
    </FormControl>
  );
};

export default TagsEdit;
